import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=loading, false=unauth, object=auth
  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);
  useEffect(() => {
    // Skip if returning from OAuth (#session_id)
    if (window.location.hash?.includes("session_id=")) {
      setUser(null);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password, empresa_id = null) => {
    const payload = { email, password };
    if (empresa_id) payload.empresa_id = empresa_id;
    const { data } = await api.post("/auth/login", payload);
    if (data?.token) localStorage.setItem("np_token", data.token);
    setUser(data);
    return data;
  };
  const register = async (payload) => {
    // payload: { email, password, name, empresa_nombre, empresa_cedula_juridica, empresa_telefono }
    const { data } = await api.post("/auth/register", payload);
    // NO auto-login: cuenta queda pendiente de aprobación.
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("np_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, register, logout, checkAuth }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
